<template>
  <div class="country-kpi-control" :class="{ 'country-kpi-smll': isSmall && !saveRoom, 'country-kpi-lg': !isSmall, 'country-kpi-xs': saveRoom }">
    <div  class="country-kpi-frame" 
          :style="{ 'border-radius': round ? '4px' : '0px' }" >
      <span class="country-kpi-text">{{ getValue() }}</span>
      <div  class="country-kpi-bar" 
            v-if="kpi" 
            :style="{ width: getWidth(), background: getColor(kpi.Result * this.factor), 'border-radius': round ? '3px' : '0px' }" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    kpi: Object,
    thresholdData: Array,
    round: Boolean,
    multiply: Boolean,
    isSmall: { type: Boolean, default: false },
    saveRoom: { type: Boolean, default: false }
  },
  methods: {
    getWidth() {
      return `${this.kpi.Result * this.factor}%`;
    },
    getValue() {
      if (this.kpi && (this.kpi.Result || this.kpi.Result === 0)) {
        return `${Math.round(this.kpi.Result * this.factor)}%`;
      }
      return 'N/A';
    },
    getColor(value) {
      if (!this.thresholdData) return null;
      return this.thresholdData.find(
        (thres) => thres.Minimum <= value && thres.Maximum >= value
      )?.Color;
    }
  },

  computed: {
    factor() {
      return this.multiply ? 100 : 1;
    }
  }
}
</script>
